import React from "react";
import MatchCard from "./MatchCard";

const MatchHistoryList = ({ history, onReveal }) => {
  return (
    <div className="space-y-6">
      {history.map((group, index) => (
        <div key={index}>
          <h3 className="text-sm text-muted-foreground mb-3 px-1">{group.date}</h3>
          <div className="space-y-2">
            {group.matches.map((match, matchIndex) => (
              <MatchCard key={matchIndex} match={match} onReveal={onReveal} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MatchHistoryList;
